import React, { Component } from 'react';
import { StyleRoot } from 'radium';
import { hot } from 'react-hot-loader';
import { BrowserRouter as Router } from 'react-router-dom';
import { Route } from 'react-router';

import HomePage from './containers/HomePage.jsx';
import ScoreContext from './scoreContext';

const styles = {
  wrapper: {
    width: '100%',
    height: '100%',
  },
};

class App extends Component {
  static parseFBResources() {
    return new Promise((resolve) => {
      if (document.getElementsByClassName('fb-video').length > 0) {
        FB.XFBML.parse();
        FB.Event.subscribe('xfbml.render', resolve);
      }
      resolve();
    });
  }

  static initFBSDK() {
    FB.init({
      appId: '1826661100918849',
      version: 'v2.7',
    });
  }

  static loadScore() {
    return fetch('score.json').then(res => res.json());
  }

  state = {
    likes: 0,
    comments: 0,
    shares: 0,
  }

  componentDidMount() {
    this.loadAnimationData();
  }


  async loadAnimationData() {
    App.initFBSDK();

    await App.parseFBResources();

    const scores = await App.loadScore();

    this.setState({
      ...scores,
    });
  }

  render() {
    const {
      likes,
      shares,
      comments,
    } = this.state;

    return (
      <StyleRoot style={styles.wrapper}>
        <ScoreContext.Provider
          value={{
            likes,
            shares,
            comments,
          }}>
          <Router>
            <Route path="/" component={HomePage} />
          </Router>
        </ScoreContext.Provider>
      </StyleRoot>
    );
  }
}

export default hot(module)(App);
